import { ssrApi } from 'api/ssr';
import { QuestionsPage } from 'components/template/questions';
import { IQuestion } from 'constants/types';

export default function Questions({ questions }: { questions: IQuestion[] }) {
  return <QuestionsPage questions={questions} />;
}

export async function getServerSideProps() {
  const { results } = await ssrApi.questions.list({ limit: 3 });

  return {
    props: { questions: results },
  };
}
